import React from 'react';
import PropTypes from 'prop-types';
// import ReactModal from 'react-modal';
import { Modal as AntModal } from 'antd';
import { useTranslation } from 'react-i18next';

import './Modal.css';

// import { Typography, Icon } from '../';
// import { useModal } from '../../contextProviders';

// if (typeof document !== 'undefined') {
//   ReactModal.setAppElement(document.getElementById('root'));
// }

const Modal = ({
  closeButton,
  shouldCloseOnEsc,
  customContentClassName = '',
  isOpen,
  title,
  onClose,
  children,
  width = 900,
}) => {
  const { t } = useTranslation('ViewerTool');
/*   const { hide } = useModal();

  const handleClose = () => {
    hide();
  };

  const renderHeader = () => {
    return (
      title && (
        <header className="flex items-center rounded-tl rounded-tr border-b-2 border-black bg-secondary-dark p-4">
          <Typography
            variant="h4"
            className="flex grow font-light text-primary-light"
            data-cy="modal-header"
          >
            {title}
          </Typography>
          {closeButton && (
            <Icon
              onClick={onClose}
              name="close"
              className="h-6 w-6 cursor-pointer text-primary-active"
            />
          )}
        </header>
      )
    );
  }; */

  return (
    // <ReactModal
    //   className="relative h-full max-h-full w-11/12 text-white outline-none  lg:w-10/12 xl:w-1/2"
    //   overlayClassName="fixed top-0 left-0 right-0 bottom-0 z-50 bg-overlay flex items-start justify-center py-16"
    //   shouldCloseOnEsc={shouldCloseOnEsc}
    //   onRequestClose={handleClose}
    //   isOpen={isOpen}
    //   title={title}
    // >
    //   {renderHeader()}
    //   <section
    //     className={`ohif-scrollbar modal-content overflow-y-auto rounded-bl rounded-br bg-primary-dark px-4 py-6 ${customContentClassName}`}
    //   >
    //     {children}
    //   </section>
    // </ReactModal>
    <AntModal
      title={<h3>{t(title)}</h3>}
      onCancel={onClose}
      keyboard={shouldCloseOnEsc}
      className={`top-[4rem] ${customContentClassName}`}
      open={isOpen}
      width={width}
      footer={null}
      closable={closeButton}
    >
      {children}
    </AntModal>
  );
};

Modal.defaultProps = {
  shouldCloseOnEsc: true,
};

Modal.propTypes = {
  closeButton: PropTypes.bool,
  shouldCloseOnEsc: PropTypes.bool,
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  onClose: PropTypes.func,
  /** The modal's content */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  width: PropTypes.number,
};

export default Modal;
